module.exports = __webpack_public_path__ + "static/media/doctorPortal.80c9ff8b.PNG";